import axios from "./instance";

// Fetch all tasks for a project
export const getTasksByProject = async (projectId) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/project-tasks/project/${projectId}`);
    return res.data;
  } catch (error) {
    console.error(`Error fetching tasks for project ${projectId}:`, error);
    throw error;
  }
};

// Create a new task
export const createTask = async (projectId, taskData) => {

  try {
    const res = await axios.post(`http://localhost:8000/api/project-tasks/project/${projectId}`, taskData);
    return res.data;
  } catch (error) {
    console.error(`Error creating task for project ${projectId}:`, error);
    throw error;
  }
};

// Update a task
export const updateTask = async (taskId, taskData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/project-tasks/${taskId}`, taskData);
    return res.data;
  } catch (error) {
    console.error(`Error updating task with ID ${taskId}:`, error);
    throw error;
  }
};

// Delete a task
export const deleteTask = async (taskId) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/project-tasks/project/${taskId}`);
    return res.data;
  } catch (error) {
    console.error(`Error deleting task with ID ${taskId}:`, error);
    throw error;
  } 
};
